export default {"src":"/_next/static/media/multiply_bold.ea5422bb.svg","height":24,"width":24};